'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanConfirmationModal = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dateFns = require('date-fns');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _thunk = require('helpers/thunk.shape');

var _thunk2 = _interopRequireDefault(_thunk);

var _multitrack = require('helpers/multitrack');

var _planChangeEffectiveDates = require('constants/plan-change-effective-dates');

var _time = require('helpers/time');

var _PlanConfirmationModal = require('./PlanConfirmationModal.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanConfirmationModal = exports.PlanConfirmationModal = function (_React$Component) {
  (0, _inherits3.default)(PlanConfirmationModal, _React$Component);

  function PlanConfirmationModal(props) {
    var _this, _this2;

    (0, _classCallCheck3.default)(this, PlanConfirmationModal);

    _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (PlanConfirmationModal.__proto__ || (0, _getPrototypeOf2.default)(PlanConfirmationModal)).call(this, props)), _this2);

    _this2.handleMaybeClick = function () {
      if (_this.props.immediateOnly || _this.props.allowImmediate && _this.state.selectedPlan === _planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY) {
        _this.handleSubmit(_planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY);
        return;
      }

      _this.handleSubmit();
    };

    _this2.handleSelectNextCycle = function () {
      _this.setState({ selectedPlan: _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE });
    };

    _this2.handleSelectImmediate = function () {
      _this.setState({ selectedPlan: _planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY });
    };

    _this2.maybeRenderError = function () {
      var error = _this.props.error;

      var errorMessage = void 0;

      if (error) {
        if (typeof error === 'string') {
          errorMessage = error;
        } else if (error.code === _PlanConfirmationModal.ERROR_NO_PAYMENT_SOURCE) {
          errorMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'planSelection.modal.errors.billingInfoMissing',
            defaultMessage: 'Oops! We were unable to process your credit card.'
          });
        } else {
          errorMessage = error.message;
        }
      }
      return errorMessage && _react2.default.createElement(
        'div',
        { className: 'error__text' },
        errorMessage
      );
    };

    _this2.state = {
      selectedPlan: _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE
    };
    return _this2;
  }

  (0, _createClass3.default)(PlanConfirmationModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          immediateOnly = _props.immediateOnly,
          allowImmediate = _props.allowImmediate,
          currentSubscription = _props.currentSubscription,
          plan = _props.plan,
          referralSource = _props.referralSource,
          prioritizeImmediate = _props.prioritizeImmediate;


      var effectiveDateOptions = void 0;
      if (immediateOnly) {
        effectiveDateOptions = [_planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY];
      } else if (allowImmediate) {
        effectiveDateOptions = [_planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY, _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE];
      } else {
        effectiveDateOptions = [_planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE];
      }

      (0, _multitrack.ec)('Manage Membership - Select Plan', {
        page_type: 'plan_switching',
        action: 'confirm_plan',
        current_plan_code: currentSubscription.plan.plan_code,
        pending_plan_id: plan.id,
        pending_plan_code: plan.plan_code,
        effective_date_options: effectiveDateOptions,
        referral_source: referralSource || '',
        prioritize_immediate: !!prioritizeImmediate
      });
    }
  }, {
    key: 'getNextCycleDate',
    value: function getNextCycleDate() {
      return (0, _time.parseUnixSecondsDate)(this.props.currentSubscription.next_cycle);
    }
  }, {
    key: 'getImmediateCycleStart',
    value: function getImmediateCycleStart() {
      return new Date();
    }
  }, {
    key: 'getImmediateCycleEnd',
    value: function getImmediateCycleEnd() {
      var nextMonth = (0, _dateFns.addMonths)(new Date(), 1);

      return (0, _dateFns.addDays)(nextMonth, -1);
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var effective = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE;
      var _props2 = this.props,
          plan = _props2.plan,
          prioritizeImmediate = _props2.prioritizeImmediate,
          referralSource = _props2.referralSource,
          switchSubscription = _props2.switchSubscription;


      if (this.isLoading()) {
        return;
      }

      switchSubscription({
        newPlanId: plan.id,
        effective: effective,
        trackingData: {
          prioritize_immediate: !!prioritizeImmediate,
          referral_source: referralSource || ''
        }
      });
    }
  }, {
    key: 'isLoading',
    value: function isLoading() {
      var _props3 = this.props,
          subscription = _props3.subscription,
          leaving = _props3.leaving;


      return subscription.loading || leaving;
    }
  }, {
    key: 'maybeRenderImmediateDetails',
    value: function maybeRenderImmediateDetails() {
      var _props4 = this.props,
          plan = _props4.plan,
          hasTax = _props4.hasTax;


      if (this.state.selectedPlan !== _planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY) {
        return;
      }

      var price = this.renderPrice();
      var tax = this.renderTax();
      var upgradePrice = this.renderPrice(plan.immediate_upgrade_price);

      var values = {
        price: price,
        date: _react2.default.createElement(_reactIntl.FormattedDate, {
          timeZone: 'utc',
          value: this.getNextCycleDate(),
          day: 'numeric',
          month: 'short'
        }),
        count: plan.org_visits_per_cycle,
        tax: hasTax ? tax : '',
        upgradePrice: upgradePrice,
        upgradedRemaining: plan.upgraded_remaining_balance,
        upgradedTotal: plan.upgraded_plan_total
      };

      return _react2.default.createElement(
        'div',
        { className: 'plan-selection__immediate__details text--left text--xs -mt-- mb' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'planSelection.modal.selection.immediate.credits.details',
          defaultMessage: 'Today, you will be charged {upgradePrice}{tax} \u2013 the difference between your current plan and your new plan. You have {upgradedRemaining} of {upgradedTotal} credits to use this month, and up to 10 credits will roll over automatically to your next month. Beginning on {date}, you will be charged {price}/mo{tax}.',
          values: values
        })
      );
    }
  }, {
    key: 'maybeRenderNextCycleModalBody',
    value: function maybeRenderNextCycleModalBody() {
      if (!this.props.allowImmediate) {
        return _react2.default.createElement(
          'div',
          { className: 'mv' },
          this.renderEffectiveDate()
        );
      }
    }
  }, {
    key: 'maybeRenderAllowImmediateModalBody',
    value: function maybeRenderAllowImmediateModalBody() {
      if (this.props.allowImmediate) {
        return _react2.default.createElement(
          'div',
          { className: 'plan-selection__allow-immediate pl' },
          _react2.default.createElement(
            'div',
            { className: 'plan-selection__options mt+ mb' },
            _react2.default.createElement(
              'div',
              { onClick: this.handleSelectNextCycle },
              _react2.default.createElement(
                'label',
                { className: 'mb+', htmlFor: 'selection-next-cycle' },
                _react2.default.createElement('input', { type: 'radio', name: 'select-next-cycle', value: _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE, checked: this.state.selectedPlan === _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE }),
                _react2.default.createElement(
                  'div',
                  { className: 'plan-selection__details ml-' },
                  _react2.default.createElement(
                    'strong',
                    { className: 'mb--' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: 'planSelection.modal.selection.option.next-cycle',
                      defaultMessage: 'Switch next cycle'
                    })
                  ),
                  this.renderEffectiveDate()
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { onClick: this.handleSelectImmediate },
              _react2.default.createElement(
                'label',
                { htmlFor: 'select-immediate' },
                _react2.default.createElement('input', { type: 'radio', name: 'select-immediate', value: _planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY, checked: this.state.selectedPlan === _planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY }),
                _react2.default.createElement(
                  'div',
                  { className: 'plan-selection__details ml-' },
                  _react2.default.createElement(
                    'strong',
                    { className: 'mb--' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: 'planSelection.modal.selection.option.immediate',
                      defaultMessage: 'Switch immediately'
                    })
                  ),
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'planSelection.modal.selection.immediate',
                    defaultMessage: 'This will take effect today'
                  })
                )
              )
            )
          ),
          this.maybeRenderImmediateDetails()
        );
      }
    }
  }, {
    key: 'maybeRenderConfirmationModal',
    value: function maybeRenderConfirmationModal() {
      var _props5 = this.props,
          prioritizeImmediate = _props5.prioritizeImmediate,
          allowImmediate = _props5.allowImmediate;


      if (prioritizeImmediate && allowImmediate) {
        return;
      }

      return _react2.default.createElement(
        'div',
        { className: 'plan-selection__body' },
        this.maybeRenderNextCycleModalBody(),
        this.maybeRenderAllowImmediateModalBody(),
        _react2.default.createElement(
          'button',
          {
            disabled: this.isLoading(),
            onClick: this.handleMaybeClick,
            className: (0, _classnames2.default)('bt bt--primary bt--lg', {
              'bt--waiting': this.isLoading()
            })
          },
          this.renderConfirmationButtonText()
        ),
        _react2.default.createElement(
          'div',
          { className: 'plan-selection__terms bg--light text--light text--sm mt+ p+ ph++' },
          this.renderTerms()
        )
      );
    }
  }, {
    key: 'maybeRenderPrioritizeImmediateModal',
    value: function maybeRenderPrioritizeImmediateModal() {
      var _props6 = this.props,
          prioritizeImmediate = _props6.prioritizeImmediate,
          allowImmediate = _props6.allowImmediate;


      if (prioritizeImmediate && allowImmediate) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            {
              disabled: this.isLoading(),
              onClick: this.handleSubmit.bind(this, _planChangeEffectiveDates.EFFECTIVE_IMMEDIATELY),
              className: (0, _classnames2.default)('bt bt--primary bt--lg mt', {
                'bt--waiting': this.isLoading()
              })
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'planSelection.modal.confirm-immediate',
              defaultMessage: 'Confirm plan change'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text--light text--sm mv' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'planSelection.modal.prioritizeImmediateTerm1',
              defaultMessage: 'You will be charged today and reset your cycle to start today. Any unused classes on your old plan will not rollover.'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'mt' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'planSelection.modal.waitMessage',
              defaultMessage: 'Wait until your next cycle ({cycleDate})',
              values: {
                cycleDate: _react2.default.createElement(_reactIntl.FormattedDate, {
                  timeZone: 'utc',
                  value: this.getNextCycleDate(),
                  day: 'numeric',
                  month: 'long'
                })
              }
            }),
            _react2.default.createElement(
              'p',
              { className: 'mt' },
              _react2.default.createElement(
                'a',
                {
                  className: (0, _classnames2.default)({
                    'plan-selection__immediate-cta--loading': this.isLoading()
                  }),
                  onClick: this.handleSubmit.bind(this, _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE)
                },
                _react2.default.createElement(
                  'strong',
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'planSelection.modal.next-cycle.cta',
                    defaultMessage: 'Confirm for your next cycle'
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'text--light text--sm mt mb0' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'planSelection.modal.prioritizeImmediateTerm2',
              defaultMessage: 'Beginning on the next cycle start date, you will automatically be charged each month for your new plan.'
            })
          )
        );
      }
    }
  }, {
    key: 'maybeRenderCreditPlanName',
    value: function maybeRenderCreditPlanName() {
      var _props7 = this.props,
          showComembershipDetails = _props7.showComembershipDetails,
          plan = _props7.plan;


      if (showComembershipDetails) {
        return;
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'planSelection.modal.credits.plan-name',
        defaultMessage: '{count}-credit plan',
        values: { count: plan.credits_per_cycle }
      });
    }
  }, {
    key: 'renderTermsLink',
    value: function renderTermsLink() {
      return _react2.default.createElement(
        'a',
        { href: '/terms', target: '_blank', rel: 'noopener noreferrer' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'planSelection.modal.terms',
          defaultMessage: 'Terms of Use'
        })
      );
    }
  }, {
    key: 'renderPrice',
    value: function renderPrice() {
      var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.plan.price;
      var plan = this.props.plan;


      return _react2.default.createElement(_reactIntl.FormattedNumber, {
        value: price,
        style: 'currency',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        currency: plan.currency_code
      });
    }
  }, {
    key: 'renderTax',
    value: function renderTax() {
      return _react2.default.createElement(
        'span',
        { className: 'ml--' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'planSelection.modal.plusTax', defaultMessage: '+tax' })
      );
    }
  }, {
    key: 'renderPrivacyLink',
    value: function renderPrivacyLink() {
      return _react2.default.createElement(
        'a',
        { href: '/privacy', target: '_blank', rel: 'noopener noreferrer' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'planSelection.modal.privacy',
          defaultMessage: 'Privacy Policy'
        })
      );
    }
  }, {
    key: 'renderTerms',
    value: function renderTerms() {
      var _props8 = this.props,
          showComembershipDetails = _props8.showComembershipDetails,
          comembershipDetails = _props8.comembershipDetails,
          immediateOnly = _props8.immediateOnly,
          hasTax = _props8.hasTax;

      var _ref = comembershipDetails || {},
          termsLink = _ref.termsLink,
          termsTitle = _ref.termsTitle;

      var price = this.renderPrice();
      var tax = this.renderTax();
      var terms = this.renderTermsLink();
      var privacy = this.renderPrivacyLink();

      if (showComembershipDetails) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'planSelection.modal.comembership.terms',
          defaultMessage: 'By switching plans you agree that beginning on the date indicated above, you will automatically be charged each month for your new plan until you cancel, which you can do on the site at any time.  By confirming your plan change, you agree to the ClassPass {terms}, the ClassPass {privacy}, the {comembership}.',
          values: {
            terms: terms,
            privacy: privacy,
            comembership: _react2.default.createElement(
              'a',
              { href: termsLink, target: '_blank', rel: 'noopener noreferrer' },
              termsTitle
            )
          }
        });
      }

      if (immediateOnly) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
          className: 'terms-text',
          id: 'planSelection.modal.terms.by-signing',
          defaultMessage: 'By signing up you agree to be charged {price}{tax} starting today, {today}, and renewed each month until you cancel, which you can do any time. You agree to the {terms} and {privacy}.',
          values: {
            price: price,
            terms: terms,
            privacy: privacy,
            today: _react2.default.createElement(_reactIntl.FormattedDate, {
              timeZone: 'utc',
              value: this.getImmediateCycleStart(),
              day: 'numeric',
              month: 'short'
            }),
            tax: hasTax ? tax : ''
          }
        });
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'planSelection.modal.terms.by-switching',
        defaultMessage: 'By switching plans you agree that beginning on the date indicated above, you will automatically be charged each month for your new plan until you cancel, which you can do on the site at any time.  You agree to the {terms} and {privacy}.',
        values: {
          terms: terms,
          privacy: privacy
        }
      });
    }
  }, {
    key: 'renderEffectiveDate',
    value: function renderEffectiveDate() {
      if (this.props.immediateOnly) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'planSelection.modal.date.immediately',
          defaultMessage: 'This will take effect immediately'
        });
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'planSelection.modal.date',
        defaultMessage: 'This will take effect on {date}',
        values: {
          date: _react2.default.createElement(_reactIntl.FormattedDate, {
            timeZone: 'utc',
            value: this.getNextCycleDate(),
            day: 'numeric',
            month: 'long'
          })
        }
      });
    }
  }, {
    key: 'renderConfirmationButtonText',
    value: function renderConfirmationButtonText() {
      if (this.props.immediateOnly) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'planSelection.modal.confirmAndStartNow',
          defaultMessage: 'Confirm plan and start now'
        });
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'planSelection.modal.confirm',
        defaultMessage: 'Confirm plan change'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props9 = this.props,
          showComembershipDetails = _props9.showComembershipDetails,
          prioritizeImmediate = _props9.prioritizeImmediate,
          plan = _props9.plan,
          hasTax = _props9.hasTax;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('modal__body', {
            'modal__plan-confirmation--prioritize-immediate': prioritizeImmediate,
            'modal__plan-confirmation--immediate': !prioritizeImmediate
          })
        },
        _react2.default.createElement(
          'div',
          { className: 'modal__column' },
          _react2.default.createElement(
            'div',
            null,
            this.maybeRenderError(),
            _react2.default.createElement(
              'div',
              { className: 'modal__confirmation-message' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'planSelection.modal.review',
                defaultMessage: 'Review your selection'
              })
            ),
            _react2.default.createElement(
              'h3',
              { className: 'mv' },
              this.maybeRenderCreditPlanName(),
              showComembershipDetails && plan.sell_name
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'planSelection.modal.price',
              defaultMessage: '{price} per month',
              values: { price: this.renderPrice() }
            }),
            _react2.default.createElement(
              'span',
              { className: 'text--regular' },
              hasTax && this.renderTax()
            ),
            _react2.default.createElement('br', null),
            this.maybeRenderConfirmationModal(),
            this.maybeRenderPrioritizeImmediateModal()
          )
        )
      );
    }
  }]);
  return PlanConfirmationModal;
}(_react2.default.Component);

PlanConfirmationModal.propTypes = {
  allowImmediate: _propTypes2.default.bool,
  comembershipDetails: _propTypes2.default.shape({
    termsLink: _propTypes2.default.string,
    termsTitle: _propTypes2.default.string
  }),
  currentSubscription: _propTypes2.default.object.isRequired,
  error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    code: _propTypes2.default.number,
    message: _propTypes2.default.string
  })]),
  hasTax: _propTypes2.default.bool,
  immediateOnly: _propTypes2.default.bool.isRequired,
  leaving: _propTypes2.default.bool,
  plan: _propTypes2.default.object.isRequired,
  prioritizeImmediate: _propTypes2.default.bool,
  referralSource: _propTypes2.default.string,
  showComembershipDetails: _propTypes2.default.bool,
  subscription: (0, _thunk2.default)(),
  switchSubscription: _propTypes2.default.func.isRequired
};